export default __webpack_public_path__ + "static/media/twitter.4bc16b9b.svg";